import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import { DivisoesComponent } from './divisoes.component';
import { DivisaoListComponent } from './divisao-list/divisao-list.component';
import { DivisaoFormComponent } from './divisao-form/divisao-form.component';
import {DivisaoApiService} from "./shared/divisao-api.service";
import {DivisaoNavigationService} from "./shared/divisao-navigation.service";
import {DivisoesService} from "./shared/divisao.service";
import {SetoresModule} from "../setores/setores.module";
import {DivisoesRoutingModule} from "./divisoes-routing.module";

@NgModule({
  imports: [
    SharedModule,
    SetoresModule,
    DivisoesRoutingModule
  ],
  providers: [
    DivisaoApiService,
    DivisaoNavigationService,
    DivisoesService
  ],
  declarations: [
    DivisoesComponent,
    DivisaoListComponent,
    DivisaoFormComponent
  ]
})
export class DivisoesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/divisoes.module.ts
 **/